import { generateIconComponent } from './icons.utils';

export const YoutubeIcon = generateIconComponent({
    name: 'YoutubeIcon',
    viewBox: '0 0 24 24',
    path: (
        <path d="M23.4985 6.64036C23.2225 5.60106 22.4092 4.78253 21.3766 4.50476C19.505 4 12 4 12 4C12 4 4.49503 4 2.62336 4.50476C1.59077 4.78258 0.777523 5.60106 0.501503 6.64036C0 8.52416 0 12.4545 0 12.4545C0 12.4545 0 16.3849 0.501503 18.2687C0.777523 19.308 1.59077 20.0924 2.62336 20.3702C4.49503 20.875 12 20.875 12 20.875C12 20.875 19.505 20.875 21.3766 20.3702C22.4092 20.0924 23.2225 19.308 23.4985 18.2687C24 16.3849 24 12.4545 24 12.4545C24 12.4545 24 8.52416 23.4985 6.64036V6.64036ZM9.54544 16.023V8.88605L15.8181 12.4546L9.54544 16.023V16.023Z" />
    ),
});
